import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useSelector } from "react-redux";
import { GetProfsForDropdownCall } from "../../redux/api/professor.api";

/**
 * Shows a "Select professor" dropdown when the current user is admin or university_admin.
 * Optional: include "My content" (value "") so they can view their own data when applicable.
 * @param {string} value - selected prof id or ""
 * @param {function} onChange - (profId: string) => void
 * @param {object} sx - MUI sx prop
 * @param {boolean} includeMyContent - if true, first option is "My content" (no prof_id)
 */
export default function ProfSelector({ value, onChange, sx = {}, includeMyContent = true }) {
  const role = useSelector((state) => state?.auth?.role);
  const currentUserId = useSelector((state) => state?.auth?.id);
  const [profs, setProfs] = useState([]);
  const [loading, setLoading] = useState(false);

  const showSelector = role === "admin" || role === "university_admin";

  useEffect(() => {
    if (!showSelector) return;
    setLoading(true);
    GetProfsForDropdownCall()
      .then((list) => setProfs(Array.isArray(list) ? list : []))
      .finally(() => setLoading(false));
  }, [showSelector]);

  if (!showSelector) return null;

  const displayValue = value ?? "";

  return (
    <FormControl
      size="small"
      sx={{
        minWidth: 220,
        "& .MuiOutlinedInput-root": { minHeight: 44 },
        ...sx,
      }}
    >
      <InputLabel id="prof-selector-label">Professor</InputLabel>
      <Select
        labelId="prof-selector-label"
        label="Professor"
        value={displayValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
      >
        {includeMyContent && (
          <MenuItem value="">
            My content
          </MenuItem>
        )}
        {profs.map((p) => (
          <MenuItem key={p.id} value={p.id}>
            {[p.first_name, p.last_name].filter(Boolean).join(" ") || p.email || p.id}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
